import { browserName, browserVersion } from "react-device-detect";

const browser = { name: browserName, version: browserVersion ? parseInt(browserVersion.split(".")[0]) : 0 };
export { browser };
